import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'suka-empty-state',
  template: `
    <div class="empty-state">
      <div class="empty-state__description">
        <h3 class="empty-state__heading">{{heading}}</h3>

        <div class="empty-state__content">
          <ng-content></ng-content>
        </div>
        <div
          *ngIf="primaryActionLabel"
          class="empty-state__actions"
        >
          <suka-button-group>
            <button
              sukaButton="primary"
              (click)="onClick('primary')"
            >
              {{primaryActionLabel}}
            </button>
            <button
              *ngIf="secondaryActionLabel"
              sukaButton="plain"
              (click)="onClick('secondary')"
            >
              {{secondaryActionLabel}}
            </button>
          </suka-button-group>
        </div>
      </div>

      <div class="empty-state__image">
        <img *ngIf="imgSrc" [src]="imgSrc" />
        <suka-icon *ngIf="!imgSrc" icon="inbox"></suka-icon>
      </div>
    </div>
  `
})
export class EmptyState {
  /**
   * Heading content.
   */
  @Input() heading = '';

  /**
   * Sets an image url for the avatar. If it is set, it displays instead of the empty icon.
   */
  @Input() imgSrc: string;

  /**
   * Primary action label content
   */
  @Input() primaryActionLabel: string;
  /**
   * Emits the primary action event.
   */
  @Output() primaryAction = new EventEmitter();

  /**
   * Secondary action label content
   */
  @Input() secondaryActionLabel: string;
  /**
   * Emits the secondary action event.
   */
  @Output() secondaryAction = new EventEmitter();

  /**
   * On button click, emits a primary o secondary action event accordingly
   */
  onClick(type: string) {
    if (type === 'primary') {
      this.primaryAction.emit('primary');
    }

    if (type === 'secondary') {
      this.secondaryAction.emit('secondary');
    }
  }
}
